import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { errorState } from "../../../recoil/error/atom";
import TopHeader from "./TopHeader";
import FullNameOccupation from "./FullNameOccupation";
import WhyJoin from "./WhyJoin";
import UnionForm from "./UnionForm";
import Signature from "./Signature";
import PrivacyRights from "./PrivacyRights";
import Footer from "./Footer";
import styles from "./JoinUnion.module.scss";
import { validateDateString } from "../common/ValidationHelper";
import Button from "react-bootstrap/Button";
const JoinUnion = (props) => {
  const popError = useSetRecoilState(errorState);
  const [fullName, setFullName] = useState("");
  const [occupation, setOccupation] = useState("");

  const [joinUnion, setJoinUnion] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [unionName, setUnionName] = useState("");
  const [doNotPass, setDoNotPass] = useState(false);
  const [doNotJoin, setDoNotJoin] = useState(false);
  const [noJoinNoPass, setNoJoinNoPass] = useState(false);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [signature, setSignature] = useState("");

  const setSignatureData = (data) => {
    setSignature(data);
  };

  const setChoicesData = ({ name, value }) => {
    console.log("name", name);
    console.log("name value", value);
    switch (name) {
      case "joinUnion":
        setJoinUnion(value);
        break;
      case "doNotPass":
        setDoNotPass(value);
        break;
      case "noJoinUnion":
        setDoNotJoin(value);
        break;
      case "noJoinNoPass":
        setNoJoinNoPass(value);
        break;
      default:
        break;
    }
  };

  const setMemberData = ({ name, value }) => {
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "role":
        setRole(value);
        break;
      case "unionName":
        setUnionName(value);
        break;
    }
  };

  const setDateData = ({ name, value }) => {
    switch (name) {
      case "day":
        setDay(value);
        break;
      case "month":
        setMonth(value);
        break;
      case "year":
        setYear(value);
        break;
      default:
        break;
    }
  };

  const setNameAndOccupation = ({ name, value }) => {
    switch (name) {
      case "fullname":
        setFullName(value);
        break;
      case "occupation":
        setOccupation(value);
        break;
      default:
        break;
    }
  };

  const validateForm = () => {
    const isRequiredFieldsFilled = fullName && occupation;

    const isUnionFieldsValid = joinUnion ? email && unionName : doNotJoin;

    const isSignatureAndDateValid = signature && day && month && year;

    if (isRequiredFieldsFilled && isUnionFieldsValid && isSignatureAndDateValid) {
      const dateString = year + "-" + month + "-" + day;
      const isValidDate = validateDateString(dateString);

      if (!isValidDate) {
        return { isValid: false, message: "Invalid signature date" };
      }
      return { isValid: true, message: "" };
    }
    return { isValid: false, message: "Please provide all mandatory fields" };
  };

  const resetForm = () => {
    const value = "";
    setFullName(value);
    setOccupation(value);
    setJoinUnion(false);
    setEmail(value);
    setPhone(value);
    setRole(value);
    setUnionName(value);
    setDoNotPass(false);
    setDoNotJoin(false);
    setNoJoinNoPass(false);
    setSignature(value);
    setDay(value);
    setMonth(value);
    setYear(value);
  };

  const submitForm = () => {
    const { isValid, message } = validateForm();

    if (isValid) {
      const data = {
        interactiveDocument: "JoinUnion",
        fullname: fullName,
        occupation: occupation,
        yesjoin: joinUnion,
        email: email,
        phone: phone,
        role: role,
        unionname: unionName,
        donotpass: doNotPass,
        nojoin: doNotJoin,
        nojoinnopass: noJoinNoPass,
        day: day,
        month: month,
        year: year,
        employeesignature: signature,
        signatureContent: signature,
      };

      props.submit(data).then((result) => {
        if (result) {
          props.redirectToList();
        }
      });
    } else {
      popError([
        {
          type: "warning",
          title: "Warning",
          message: message,
        },
      ]);
    }
  };

  return (
    <div className={`join-union-form ${styles.joinUnionForm}`}>
      <div className="container">
        <TopHeader />
        <div className={styles.innerContainer}>
          <div className="container">
            <p>
              If you are an employer, you must provide this form to your employees along with a list of unions with
              agreements that cover the employee’s role.
            </p>
            <h3 style={{ color: "#00BCE8", fontWeight: "bold" }}>
              COMPLETE AND RETURN THIS FORM TO YOUR EMPLOYER IF YOU WANT TO JOIN A UNION
            </h3>
            <p>
              If you have started a role that is covered by a{" "}
              <a href="https://www.employment.govt.nz/fair-work-practices/unions-and-bargaining/collective-agreements">
                collective agreement
              </a>{" "}
              between your employer and a union, you can complete and return this form to your employer to indicate your
              intention to join a union.
            </p>
          </div>
          <div>
            <FullNameOccupation
              setNameAndOccupation={setNameAndOccupation}
              fullName={fullName}
              occupation={occupation}
            />
            <WhyJoin />
            <UnionForm
              setMemberData={setMemberData}
              setChoicesData={setChoicesData}
              joinUnion={joinUnion}
              email={email}
              phone={phone}
              role={role}
              unionName={unionName}
              doNotPass={doNotPass}
              doNotJoin={doNotJoin}
              noJoinNoPass={noJoinNoPass}
            />

            <Signature
              setDateData={setDateData}
              setSignatureData={setSignatureData}
              day={day}
              month={month}
              year={year}
              signature={signature}
            />
            <div className={styles.unionFormBtn}>
              <Button type="button" onClick={resetForm}>
                RESET FORM
              </Button>
              &nbsp;&nbsp;
              <Button type="button" onClick={submitForm}>
                SUBMIT FORM
              </Button>
            </div>
            <PrivacyRights />
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinUnion;
